import { Answer, Api as AnswersApi } from '@legalshield/frontend-commons-fetch/answers';

import { CreateAnswersError } from '../errors/CreateAnswers.error';

const userId = 'b6a1053b-fc01-4acc-9689-768609f4f2d9';

const answersApi = new AnswersApi();
const createAnswers = async (answer: Answer): Promise<Answer> => {
  const response = await answersApi.v1.publicAnswersCreateAnswer(userId, answer);

  if (!response.ok) {
    throw new CreateAnswersError();
  }

  return response.data;
};

export default createAnswers;
